import { Accordion, AccordionDetails, AccordionSummary, Grid } from "@mui/material/index";
import { CBCreationOfProps } from "../types";
import { ExpandMore } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import CustomerBaseMainInvoicingAddressDetails from "./CustomerBaseMainInvoicingAddressDetails";
import CustomerBaseExtraAddressesDetails from "./extraAddresses/CustomerBaseExtraAddressesDetails";
import CBAccordionTitle from "./CBAccordionTitle";

const CustomerBaseInvoicingAddressesDetails = ({ creationOf}: CBCreationOfProps) => {

    const { t } = useTranslation("customerbase");
    const isCreationMode = !!creationOf;

    return (
        <Accordion defaultExpanded={isCreationMode}>
            <AccordionSummary expandIcon={ <ExpandMore />}>
                <CBAccordionTitle 
                    section={"cbInvoicingAddress"}
                    label={ t("tabs.accordionsLabels.cbInvoicingAddresses") }
                /> 
            </AccordionSummary>
            <AccordionDetails> 
                <Grid container alignItems={"center"} spacing={2}>
                    <Grid item xs={12}>
                        <CustomerBaseMainInvoicingAddressDetails creationOf={creationOf}/>
                    </Grid>
                    <Grid item xs={12}>
                        <CustomerBaseExtraAddressesDetails creationOf={creationOf}/>
                    </Grid> 
                </Grid>
            </AccordionDetails>
        </Accordion>
    )

}

export default CustomerBaseInvoicingAddressesDetails;